import { Link } from "react-router-dom";

export default function PayCancel() {
  return (
    <div className="min-h-screen bg-cream grid place-items-center px-5">
      <div className="bg-white border border-border/60 rounded-2xl p-10 max-w-md w-full text-center">
        <h1 className="display text-2xl font-semibold">Payment cancelled</h1>
        <p className="text-muted-foreground text-sm mt-2">No charge was made. You can pay later from the link we sent you.</p>
        <Link to="/" className="inline-block mt-6 text-blue-brand hover:underline">Back to home</Link>
      </div>
    </div>
  );
}
